import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { getInitials } from '@/lib/format'

interface AuthorAvatarProps {
    name: string | null
    avatar: string | null
    avatarAlt?: string | null
    className?: string
}

/* The author's photo when one is set in the CMS, otherwise their initials. */
export const AuthorAvatar: FC<AuthorAvatarProps> = ({
    name,
    avatar,
    avatarAlt,
    className
}): ReactNode => {
    if (avatar) {
        return (
            <img
                src={avatar}
                alt={avatarAlt ?? ''}
                loading='lazy'
                decoding='async'
                className={cn('shrink-0 rounded-full object-cover', className)}
            />
        )
    }

    return (
        <span
            aria-hidden='true'
            className={cn('inline-flex shrink-0 items-center justify-center rounded-full bg-accent font-heading text-accent-foreground', className)}
        >
            {getInitials(name)}
        </span>
    )
}
